import Vue from 'vue';

import { GRADES } from '@/constants/school-grades';

export default Vue.filter('grade', value => value && GRADES.find(grade => grade.data === value).view);


// WEBPACK FOOTER //
// ./src/filters/grade.js